import { Manager } from 'generated/api';
import { createResettableSlice } from 'careand-redux/utils/makeResettable';
import { unwrap } from 'careand-redux/utils/unwrap';
import { api } from '../api/ApiThunks';

export interface ManagersState {
  byId: Record<string, Manager | undefined>;
}

const initialState: ManagersState = {
  byId: {},
};

const slice = createResettableSlice({
  name: 'Managers',
  initialState,
  reducers: {
    receiveUpdatedManager: unwrap(insert),
  },
  extraReducers: (builder) =>
    builder.addCase(api.Tenants.listManagers.fulfilled, (state, action) => {
      const managers = action.payload;
      state.byId = {};
      managers.forEach((manager) => {
        state.byId[manager.id!] = manager;
      });
    }),
});

function insert(state: ManagersState, payload: Manager | Manager[]) {
  if (Array.isArray(payload)) {
    payload.forEach((it) => {
      state.byId[it.id!] = it;
    });
  } else {
    state.byId[payload.id!] = payload;
  }
}

export const managerActions = slice.actions;
export default slice.reducer;
